import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { motion } from 'framer-motion';

const transition = {
    ease: 'easeOut',
    duration: 0.15
};
const variants = {
    enter: {
        y: 0,
        opacity: 1,
        transition
    },
    exit: {
        y: -5,
        opacity: 0,
        transition
    }
};
const FlyoutMenu = (_param)=> {
    var { className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className"
    ]);
    return React__default.createElement(motion.ul, swcHelpers.extends({}, rest, {
        role: "menu",
        className: classnames(`flyout-menu`, className),
        variants: variants,
        initial: "exit",
        animate: "enter",
        exit: "exit"
    }));
};
var FlyoutMenu$1 = FlyoutMenu;

export { FlyoutMenu$1 as default };
//# sourceMappingURL=FlyoutMenu.js.map
